// PlayGame.jsx
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import Button1 from "./button1.jsx";
import Button2 from "./button2.jsx";
import HowTo from "./HowTo.jsx";
import "../styles/readypage.css";

function ReadyPage() {
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <div className="container">
      <h1>Florida Man Game</h1>
      <img
        alt=""
        src="/floridasign.webp"
        style={{ width: "300px", height: "auto", borderRadius: "20px" }}
      />
      {errorMessage ? (
        <div>
          <h1>{errorMessage}</h1>{" "}
          <Button1
            onClick={() =>
              (window.location.href = "https://www.theendoftheword.com/")
            }
          >
            New Game
          </Button1>
        </div>
      ) : (
        <div className="buttons">
          {/* <h1>
            Word chain length {incomingWordChain ? incomingWordChain : "0"}
          </h1> */}
          <Button1 onClick={() => navigate("/play", { replace: true })}>
            Play
          </Button1>
          <Button2 onClick={openModal}>How to Play</Button2>
        </div>
      )}

      <HowTo isOpen={showModal} onClose={closeModal}>
        <h2>How to Play</h2>

        <p>1: Tap a Florida Man</p>
        <p>2: Then Tap a Headline to match that Florida Man</p>
        <p>3: You have 3 oranges, oranges = turns</p>
        <p>5: You can only play once a day.</p>
      </HowTo>
    </div>
  );
}

export default ReadyPage;
